import { AspectRatio, Box, Grid, Stack, Typography } from '@mui/joy'
import Image from 'next/image'
import Link from 'next/link'
import Section from '../../Section/Section'
import { Button } from '../../Button'
import { Flex } from '../../Flex'

function Step({ step, title, description }) {
    return (
        <Flex>
            <Box position="relative">
                <Flex
                    bgcolor="#e3eff6"
                    width={64}
                    height={64}
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    sx={
                        step < 3 && {
                            '&:before': {
                                content: '""',
                                width: '1px',
                                height: 'calc(100% - 64px - 16px)',
                                bgcolor: '#0d417d',
                                position: 'absolute',
                                left: 32,
                                top: 'calc(64px + 8px)',
                            },
                        }
                    }
                >
                    <Typography textColor="#0d417d">STEP</Typography>
                    <Typography textColor="#0d417d" level="h4">
                        {step}
                    </Typography>
                </Flex>
            </Box>
            <Box pl={6} flex={1} pb={4}>
                <Typography textColor="#0d417d" level="h6">
                    {title}
                </Typography>
                <Typography level="p">{description}</Typography>
            </Box>
        </Flex>
    )
}

export default function Steps({ title, blocks, primaryBtn, heroImage }) {
    return (
        <Section>
            <Grid container alignItems="center">
                <Grid xs={12} sm={6}>
                    <Typography level="h3" textColor="#0d417d" pb={12}>
                        {title}
                    </Typography>
                    <Stack pr={12}>
                        {blocks.map((block, index) => (
                            <Step
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                step={index + 1}
                                title={block.title}
                                description={block.description}
                            />
                        ))}
                    </Stack>
                    <Link href={primaryBtn?.link || '#'} target="_blank">
                        <Button>{primaryBtn?.title}</Button>
                    </Link>
                </Grid>
                <Grid xs={12} sm={6} position="relative">
                    <AspectRatio ratio="1 / 1">
                        <Image
                            quality={80}
                            src={heroImage?.url}
                            fill
                            alt={heroImage?.alt}
                            style={{
                                borderRadius: '0% 15% 0% 15%',
                                objectFit: 'cover',
                                overflow: 'hidden',
                            }}
                        />
                    </AspectRatio>
                </Grid>
            </Grid>
        </Section>
    )
}
